var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialog-bottom",
          attrs: {
            title:
              _vm.editDialogConfig.isCreate === 0 ? "添加员工" : "编辑员工",
            visible: _vm.editDialogConfig.visible,
            "destroy-on-close": "",
            "close-on-click-modal": false,
            width: "540px",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.editDialogConfig, "visible", $event)
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "editPram",
              attrs: {
                rules: _vm.rules,
                model: _vm.editPram,
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "关联用户：", prop: "userId" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "upLoadPicBox",
                      on: { click: _vm.handlerChangeUser },
                    },
                    [
                      _vm.editPram.avatar
                        ? _c("div", { staticClass: "pictrue" }, [
                            _c("img", { attrs: { src: _vm.editPram.avatar } }),
                          ])
                        : _c("div", { staticClass: "upLoad" }, [
                            _c("i", {
                              staticClass: "el-icon-camera cameraIconfont",
                            }),
                          ]),
                      _c("div", { staticClass: "nick" }, [
                        _vm._v(_vm._s(_vm.editPram.nickName)),
                      ]),
                      _c("div", { staticClass: "from-tips" }, [
                        _vm._v(
                          "一个用户只能在整个平台成为一家商户的服务员工，编辑不可修改关联用户"
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "证件照：", prop: "idPhoto" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "upLoadPicBox",
                      on: {
                        click: function ($event) {
                          return _vm.modalPicTap(false)
                        },
                      },
                    },
                    [
                      _vm.editPram.idPhoto
                        ? _c("div", { staticClass: "pictrue" }, [
                            _c("img", { attrs: { src: _vm.editPram.idPhoto } }),
                          ])
                        : _c("div", { staticClass: "upLoad" }, [
                            _c("i", {
                              staticClass: "el-icon-camera cameraIconfont",
                            }),
                          ]),
                      _c("div", { staticClass: "from-tips" }, [
                        _vm._v(
                          "用于移动端工单管理工作台展示，建议：80*80PX，大小不超过5KB。"
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "员工姓名：", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入员工姓名" },
                    model: {
                      value: _vm.editPram.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.editPram, "name", $$v)
                      },
                      expression: "editPram.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "联系电话：", prop: "phone" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入手机号" },
                    model: {
                      value: _vm.editPram.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.editPram, "phone", $$v)
                      },
                      expression: "editPram.phone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "排序：" } },
                [
                  _c("el-input-number", {
                    attrs: { "step-strictly": "", min: 0, max: 9999 },
                    model: {
                      value: _vm.editPram.sort,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.editPram,
                          "sort",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "editPram.sort",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态：", prop: "status" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": 1,
                      "inactive-value": 0,
                      "active-text": "开启",
                      "inactive-text": "关闭",
                    },
                    model: {
                      value: _vm.editPram.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.editPram, "status", $$v)
                      },
                      expression: "editPram.status",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handlerClose()
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "debounceClick",
                      rawName: "v-debounceClick",
                      value: _vm.handlerSubmit,
                      expression: "handlerSubmit",
                    },
                  ],
                  attrs: { type: "primary" },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "关联用户列表",
            visible: _vm.userVisible,
            width: "900px",
            "append-to-body": true,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.userVisible = $event
            },
          },
        },
        [
          _vm.userVisible
            ? _c("userList", {
                attrs: { userType: "all" },
                on: { getRow: _vm.getRow },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }